import { Component, ViewEncapsulation, inject } from '@angular/core';
import { VIEWS } from '../../shared/providers';
import { ExplorerService } from '../../services/explorer.service';
import { TranslateModule } from '@ngx-translate/core';

/** Etichette italiane delle viste registrate in VIEWS (nome interno -> chiave di traduzione). */
const VIEW_LABELS: { [name: string]: string } = {
    Icons: 'filemanager.ui.view_cards',
    List: 'filemanager.ui.view_list',
};

@Component({
    selector: 'nxe-view-switcher',
    templateUrl: './view-switcher.component.html',
    styleUrls: ['./view-switcher.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [TranslateModule],
})
export class ViewSwitcherComponent {
    private explorerService = inject(ExplorerService);
    protected views = inject(VIEWS);
    currentView:string = this.explorerService.currentView$.getValue();
    viewLabel(view: string): string {
        return VIEW_LABELS[view] || view;
    }

    setView(view: string) {
        this.currentView = view
        this.explorerService.currentView$.next(view);
    }
}
